/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-06-17 17:44:34
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-06-17 17:51:57
 * @FilePath: /unifyxp-v2-store-portal/src/components/LinkModule/Components/Loading/index.tsx
 */
import React from 'react';
import { Spin } from 'antd';

function Loading() {
  return (
    <Spin spinning={true}>
      <div style={{ height: '400px', width: '100%' }} />
    </Spin>
  );
}

export default Loading;
